<template>
  <div class="phone-area-page">
    <mt-index-list :height="height">
      <template v-for="(item, index) in areaCodeList">
        <mt-index-section v-if="item.data.length > 0" :key="index" :index="item.letter">
          <div v-for="(val, ind) in item.data" class="cell_item" :key="ind" @click="chooseCode(val[1])">
            <mt-cell :class="val[1] === areaCode ? 'active' : ''"  :title="val[0]" :value="`+${val[1]}`"></mt-cell>
          </div>
        </mt-index-section>
      </template>
    </mt-index-list>
  </div>
</template>

<script>
import areaCode from '@/assets/data/areaCode.json';
export default {
  name: 'phone-area',
  data() {
    return {
      areaCodeList: areaCode,
      areaCode: this.code,
      height: document.body.clientHeight,
      type: 1
    }
  },
  activated() {
    this.areaCode = this.$route.params.code || '86'
    this.type = this.$route.params.type || 1
  },
  methods: {
    chooseCode(val) {
      this.areaCode = val
      console.log(val);
      const path = this.type === 1 ? 'login' : 'subVip-submitDetails'
      this.$router.replace({
        name: path,
        params: {
          code: this.areaCode
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.phone-area-page {
  width: 100%;
  height: 100%;
  background-color: #fff;
  /deep/ .mint-cell-wrapper{
    font-size: 14px;
  }
  /deep/ .mint-indexlist-navitem{
    padding:4px 8px;
  }
  .active {
    background-color: #eee;
  }
  .cell_item{
    margin-right: 5px;
  }
}
</style>
